var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15,30A15,15,0,0,1,4.393,4.393,15,15,0,0,1,25.607,25.607,14.9,14.9,0,0,1,15,30ZM9.933,12.657a1,1,0,0,0-.707.293L8.053,14.123a1,1,0,0,0,0,1.414l5.312,5.313a1,1,0,0,0,1.415,0l7.9-7.9a1,1,0,0,0,0-1.414l-1.173-1.173a1,1,0,0,0-1.414,0l-6.019,6.018L10.641,12.95A1,1,0,0,0,9.933,12.657Z","fill":"#fff"}));
}

CheckCircle.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
